<template lang="pug">
  article.admin(:class="{'is-board': $route.meta.board}")
    header.admin-header
      .max-width
        .row.main-row.apart.center
          .col
            .row.gap-2.center
              .col
                router-link(:to="{name: 'AdminDashboard'}")
                  img.logo-horizontal(src="../../assets/images/logo-horizontal.svg")
                  img.logo-icon(src="../../assets/images/logo-icon.svg")
                  //-span Feature Watch
              .col(v-if="company && company.beta.changelog")
                router-link.header-link(:to="{ name: 'PublicChangelog' }") Changelogs
          .col.right(v-if="user.isAuthenticated")
            .row.center.gap-1
              .col
                router-link.header-link(v-if="$route.name === 'AdminDashboard'", :to="{name: 'PublicDashboard'}") Public View
                router-link.header-link(v-if="$route.name === 'PublicDashboard'", :to="{name: 'Dashboard'}") Admin View
                
                div(v-if="board && board.public")
                  router-link.header-link(v-if="$route.name === 'AdminBoard'", :to="{name: 'PublicBoard'}") Public View
                  router-link.header-link(v-if="$route.name === 'PublicBoard'", :to="{name: 'AdminBoard'}") Admin View

                  router-link.header-link(v-if="$route.name === 'AdminFeature'", :to="{name: 'PublicFeature'}") Public View
                  router-link.header-link(v-if="$route.name === 'PublicFeature'", :to="{name: 'AdminFeature'}") Admin View
              .col
                UserNotifications
              .col
                DropdownMenu(type="header")
                  template(slot="toggle")
                    UserAvatar(:user="user", size="header")
                  template(slot="menu")
                    .list-menu
                      router-link.list-item(:to="{ name: 'SettingsAccount' }") Settings
                    .list-menu
                      .list-item(@click="logout") Logout
              .col.create-feature(v-if="$route.meta.board")
                router-link.button.primary-button(:to="{ name: 'CreateFeature' }")
                  font-awesome-icon(:icon="['fas','plus']")
    .page
      router-view(:key="$route.fullPath")
</template>

<script>

import { mapState, mapGetters } from 'vuex'

import UserNotifications from '@/components/notifications/UserNotifications'

export default {
  components: {
    UserNotifications
  },
  beforeMount () {
    this.$store.dispatch('user/authenticate')
    this.$store.dispatch('getDetail')
    this.$store.dispatch('getCompany')
    this.$store.dispatch('boards/getBoards')
    //console.log(this.$route)

    this.$store.dispatch('getTags')

  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      board: 'boards/selected',
    }),
    ...mapState({
      company: state => state.company,
      user: state => state.user
    })
  },
  methods: {
    logout () {
      this.$store.dispatch('user/logout')
      .then(() => {
        this.$router.push({name: 'PublicDashboard'})
      })
    }
  }
}

</script>

<style lang="stylus" scoped>
  .admin
    img.logo-horizontal
      height 24px
    .header-link
      color #fff
    
    .logo-icon
      display none
      height 24px
      
    +for_breakpoint(mobile)
      .logo-horizontal
        display none
      .logo-icon
        display inline-block

    .create-feature
      +for_breakpoint(desktop)
        display none

</style>
